// extracted by mini-css-extract-plugin
export default {"linkTitle":"cn_xsxxhJzr_Er2SQW7E__linkTitle___"};